<template>
  <main>
    <b-modal
      id="modalHomework"
      centered
      hide-footer
      hide-header
      hide-actions
      no-close-on-backdrop>
      <section class="c-modal-lection">
        <div
          class="c-modal-lection__dialog"
        >
          <header class="c-banner position-relative overflow-hidden">
            <figure class="c-banner__image">
              <img
                class="w-100 h-100 of--cover"
                src="../../../assets/images/lection/homework/banner.png"
                alt="" srcset=""
              />
            </figure>
            <div class="c-banner__body position-absolute white w-100 h-100">
              <div class="row justify-content-center">
                <div class="col-12 col-md-10">
                  <h3 class="fs-25 w-bold mb-2 text-center">
                    Confirma <span class="pri-color">tus datos</span>
                  </h3>
                  <p class="mb-0 fs-18 w-medium text-center">
                    Los siguientes datos actualizarán tu perfil y
                    serán utilizados para todos su certificados
                  </p>
                </div>
              </div>
            </div>
          </header>
          <section class="p-3 p-lg-4">
            <form class="c-form c-form--ghost mb-4">
              <div class="row mb-2">
                <div class="col col-12 col-md-6 mb-4 mb-md-0">
                  <p class="c-form__label mb-1">Nombres</p>
                  <input
                    type="text"
                    class="c-form__input w-100"
                    v-model="user.firstname"
                    placeholder="ej. Edward"
                  />
                </div>
                <div class="col col-12 col-md-6">
                  <p class="c-form__label mb-1">Apellidos</p>
                  <input
                    type="text"
                    class="c-form__input w-100"
                    v-model="user.lastname"
                    placeholder="ej. Espinoza"
                  />
                </div>
              </div>
              <p class="mb-0 w-medium">Solo puedes modificarlos una vez</p>
            </form>
            <div class="d-flex aligm-items-center justify-content-end">
              <button class="c-link c-link--black" @click="closeHomeworkModal">Cancelar</button>
              <button
                :disabled="!userNameFilled"
                class="c-button c-button--primary ms-3"
                :class="{ loading : homework.isLoading }"
                @click="sendHomework">
                {{ (homework.isLoading) ? 'Enviando...' : 'Aceptar y enviar' }}
                <img
                  class="c-button__spinner"
                  src="../../../assets/images/animations/spinner-white.png"
                  alt="loading"
                />
              </button>
            </div>
          </section>
        </div>
      </section>
    </b-modal>
  </main>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      user: window.arcux.user,
      homework: {
        isLoading: false,
        sent: false,
      },
    }
  },
  computed: {
    userNameFilled: {
      get: function(){
        return this.user.firstname && this.user.lastname && this.user.firstname.length > 3 && this.user.lastname.length > 3;
      },
    },
  },
  methods: {
    closeHomeworkModal: function() {
      this.$bvModal.hide('modalHomework');
    },
    sendHomework: function() {
      this.homework.isLoading = true;

      this.$emit('send-homework');
    },
  },
}
</script>
